// @flow
import React from "react"
import { compose, type HOC, withStateHandlers, withHandlers } from "recompose"
import withConnect from "hoc/withConnect"
import withPassport from "hoc/withPassport"
import { Text } from "componentsStyled/Typography/Texts"
import Checkbox from "components/Checkbox"
import { selectActivity } from "data/app/selectors"
import { selectSearchParams } from "data/search/selectors"
import type { SearchParams } from "data/search/types"
import { CheckboxWrap } from "./styled"

const PassportFilter = ({ data, discountId, isSelected, handleClick }) => (
  <React.Fragment>
    <Text black book nowrap>
      Show only Passport partners
    </Text>
    <CheckboxWrap>
      <Checkbox onClick={handleClick} value={isSelected} />
    </CheckboxWrap>
  </React.Fragment>
)

const mapStateToProps = state => ({
  activity: selectActivity(state),
  params: selectSearchParams(state),
})

type Outter = {|
  onChange: ({ discountId: number | mixed }) => mixed,
  value: ?number,
  params: SearchParams,
|}

const enhancer: HOC<*, Outter> = compose(
  withConnect(mapStateToProps),
  withPassport(),
  withStateHandlers(
    (props) => ({
      isSelected: Boolean(props.value),
    }),
    {
      toggleSelect: (props) => () => ({ isSelected: !props.isSelected }),
    },
  ),
  withHandlers({
    handleClick: props => () => {
      props.toggleSelect()

      const discountId = props.isSelected ? undefined : props.discountId

      return props.onChange({ discountId })
    },
  }),
)

export default enhancer(PassportFilter)



// WEBPACK FOOTER //
// ./src/searchFilters/FilterComponents/PassportFilter/index.js